import React from 'react';
import { useSelector } from 'react-redux';

import { selectAIContentLoading } from '../../../../pages/contentOptimizer/contentPage/content/briefTab/content/tabsContent/store/contentBriefsOutline.selectors';

import useOutlineHeadingOptions from '../../hooks/outline/useOutlineHeadingOptions';

import AIButton from '../../../aiButton/AIButton';
import HeadingCounter from '../buttons/HeadingCounter';
import HeadingSection from '../buttons/HeadingSection';
import ListButtonsSection from '../buttons/ListButtonsSection';
import UndoRedoButtonsSection from '../buttons/UndoRedoButtonsSection';

const OutlineEditorToolbarSections = () => {
    const aiContentLoading = useSelector(selectAIContentLoading);

    const headingOptions = useOutlineHeadingOptions();

    return (
        <>
            <HeadingSection disabled={aiContentLoading} headingOptions={headingOptions} />
            <ListButtonsSection disabled={aiContentLoading} showTextAlign={false} />
            <UndoRedoButtonsSection disabled={aiContentLoading} />
            <AIButton />
            <HeadingCounter />
        </>
    );
};

export default OutlineEditorToolbarSections;
